import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Logger } from '@app/core';
import LatLng = google.maps.LatLng;
import DistanceMatrixService = google.maps.DistanceMatrixService;

const log = new Logger('DistanceService');

@Injectable({
  providedIn: 'root',
})
export class DistanceService {
  constructor() {}

  getRoadDistance(
    startCoordinates: any,
    endCoordinates: any,
    travelMode: google.maps.TravelMode = google.maps.TravelMode.WALKING
  ): Observable<number> {
    log.debug('getRoadDistance', startCoordinates, endCoordinates);

    if (!startCoordinates.lat || !startCoordinates.long || !endCoordinates.lat || !endCoordinates.long) {
      // @todo: some error
      return of();
    }
    return new Observable((observer) => {
      const dm: DistanceMatrixService = new google.maps.DistanceMatrixService();

      dm.getDistanceMatrix(
        {
          travelMode: travelMode,
          origins: [new google.maps.LatLng(startCoordinates.lat, startCoordinates.long)],
          destinations: [new google.maps.LatLng(endCoordinates.lat, endCoordinates.long)],
        },
        (response: any, status: any) => {
          if (status !== google.maps.DirectionsStatus.OK || !response.rows[0].elements[0].distance) {
            observer.error('Cant get information from google');
          } else {
            observer.next(response.rows[0].elements[0].distance.value / 1000);
          }
        }
      );
    });
  }

  /**
   * Връща целия json(не обработен) както идва от гоогле
   * @param startCoordinates startCoordinates
   * @param endCoordinates endCoordinates
   * @param travelMode travelMode default is DRIVING
   */
  getDistance(startCoordinates: any, endCoordinates: any, travelMode: string = 'DRIVING'): Observable<number> {
    log.debug('getDistance', startCoordinates, endCoordinates);

    if (!startCoordinates.lat || !startCoordinates.long || !endCoordinates.lat || !endCoordinates.long) {
      // @todo: some error
      return of();
    }
    return new Observable((observer) => {
      const dm = new google.maps.DistanceMatrixService();

      dm.getDistanceMatrix(
        {
          travelMode: google.maps.TravelMode[travelMode],
          origins: [new google.maps.LatLng(startCoordinates.lat, startCoordinates.long)],
          destinations: [new google.maps.LatLng(endCoordinates.lat, endCoordinates.long)],
        },
        (response: any, status: any) => {
          log.debug('response', response, 'status', status);
          if (status !== google.maps.DirectionsStatus.OK || !response.rows[0].elements[0].distance) {
            observer.error('Cant get information from google');
          } else {
            observer.next(response);
          }
        }
      );
    });
  }

  getMultipleRoadDistances(startCoordinates: Array<any>, endCoordinates: any): Observable<number> {
    log.debug('getMultipleRoadDistances', startCoordinates, endCoordinates);

    return new Observable((observer) => {
      const dm = new google.maps.DistanceMatrixService();

      const origins: Array<google.maps.LatLng> = [];

      startCoordinates.forEach((coordinate) => {
        origins.push(new google.maps.LatLng(coordinate.lat, coordinate.long));
      });
      dm.getDistanceMatrix(
        {
          travelMode: google.maps.TravelMode.DRIVING,
          origins: origins,
          destinations: [new google.maps.LatLng(endCoordinates.lat, endCoordinates.long)],
        },
        (response: any, status: any) => {
          if (status !== google.maps.DirectionsStatus.OK) {
            observer.error('Cant get information from google');
          } else {
            observer.next(
              response.rows.map((rows: any) => {
                return rows.elements[0].distance ? rows.elements[0].distance.value / 1000 : 'error';
              })
            );
          }
        }
      );
    });
  }

  drawRoute(
    startCoordinates: { lat: number; long: number },
    endCoordinates: { lat: number; long: number },
    map: google.maps.Map,
    travelMode: string = 'DRIVING',
    existingRenderer: google.maps.DirectionsRenderer
  ): Observable<google.maps.DirectionsResult> {
    return new Observable((observer) => {
      const directionsService = new google.maps.DirectionsService();

      existingRenderer.setMap(map);

      const request: google.maps.DirectionsRequest = {
        origin: new google.maps.LatLng(startCoordinates.lat, startCoordinates.long),
        destination: new google.maps.LatLng(endCoordinates.lat, endCoordinates.long),
        travelMode: google.maps.TravelMode[travelMode as keyof typeof google.maps.TravelMode],
      };

      directionsService.route(request, (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          existingRenderer.setDirections(result);
          observer.next(result); // success
          observer.complete();
        } else {
          observer.error('Directions request failed: ' + status);
        }
      });
    });
  }

}
